//# sourceMappingURL=/usr/local/google/home/mmalerba/flex-layout/src/lib/media-query/breakpoints/break-point.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/flex-layout/media-query/breakpoints/break-point.js
// module id = ../../../flex-layout/media-query/breakpoints/break-point.js
// module chunks = 3